// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserInfo_wrapper__Wt0wb","image":"UserInfo_image__mt1g8","content":"UserInfo_content___GJX_","name":"UserInfo_name__6SNk2","signOut":"UserInfo_signOut__IIPDT"};